import './css/base.css';
import React, {Component}     from 'react';
import {MuiThemeProvider}     from 'material-ui';
import environment            from './app/environment';
import InitScreen             from './components/initScreen'
import app                    from './state/app';
import Router                 from './components/router'
import mapScreen              from './screens/map';
import searchScreen           from './screens/search';
import scanScreen             from './screens/scan';
import settingsScreen         from './screens/settings';
import dataManager            from './core/dataManager';
import appTheme               from './app/theme';
import registerSw from './registerServiceWorker';

const INIT_STEP        = 'init';
const INSTALL_STEP     = 'installing';
const POSTINSTALL_STEP = 'postinstall';
const COMPLETE_STEP    = 'complete';

export default class App extends Component {
    constructor(params) {
        super(params);

        console.log(this.theme);

        this.state = {
            step: INIT_STEP
        }
    }

    registerServiceWorker() {
        return registerSw();
    }

    async checkForUpdate() {
        return dataManager.sync();
    }

    async componentDidMount() {
        await environment.recoginze()
        app.registerScreen(mapScreen);
        app.registerScreen(searchScreen);
        app.registerScreen(scanScreen);
        app.registerScreen(settingsScreen);

        await this.checkForUpdate();
        await this.registerServiceWorker();
        this.setState({step: COMPLETE_STEP});
    }

    render = () => <MuiThemeProvider muiTheme={appTheme}>
        {this.state.step === COMPLETE_STEP ?
            <Router screens={app.getScreens()}/>
            :
            <InitScreen></InitScreen>
        }
    </MuiThemeProvider>
}



// WEBPACK FOOTER //
// ./src/App.js